const STYLES = {
    pending: "bg-yellow-50 text-yellow-700 border-yellow-200",
    approved: "bg-green-50 text-green-700 border-green-200",
    active: "bg-green-50 text-green-700 border-green-200",
    rejected: "bg-red-50 text-red-700 border-red-200",
    expired: "bg-red-50 text-red-700 border-red-200",
    verified: "bg-blue-50 text-blue-700 border-blue-200",
};

export default function StatusBadge({ status, testId }) {
    const cls = STYLES[status] || "bg-slate-50 text-slate-700 border-slate-200";
    return (
        <span
            data-testid={testId || `status-badge-${status}`}
            className={`inline-flex items-center px-2.5 py-1 text-xs font-medium uppercase tracking-wide border rounded-full ${cls}`}
        >
            {status}
        </span>
    );
}
